module.exports = __webpack_public_path__ + "img/banner-3.cf4987e9.jpg";